/**
 * DevExtreme (core/renderer.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var rendererBase = require("./renderer_base");
module.exports = rendererBase.get();



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/core/renderer.js
// module id = ../../../../devextreme/core/renderer.js
// module chunks = common